import * as Yup from 'yup'
import { formHelper } from '@/features/profile/helpers'

const { emailsValidation } = formHelper.emails

export const validationSchema = Yup.object().shape({
  ...emailsValidation,
})
